import { isString } from 'lodash';
import { useCallback } from 'react';
import { validatePolish } from 'validate-polish';

import { MedicalLeavePuePayer } from '@dreryk/egabinet-ezla-frontend-api';

import { FormContextValues, Validate } from '@dreryk/react-common';
import { componentsTranslationKeys, TextInput } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';

export type PayerIdentificationNumberFieldProps = Pick<
   FormContextValues<{
      payers: MedicalLeavePuePayer[] | null;
   }>,
   'register'
>;

export const PayerIdentificationNumberField = (props: PayerIdentificationNumberFieldProps): JSX.Element => {
   const validate: Validate = useCallback((data, getValue) => {
      const identificationNumberType = getValue('payers.0.identificationNumberType');
      switch (identificationNumberType) {
         case 'NIP':
            return isString(data) && validatePolish.nip(data) ? true : commonTranslationKeys.invalidNIP;
         case 'PESEL':
            return isString(data) && validatePolish.pesel(data) ? true : componentsTranslationKeys.invalidPESEL;
         default:
            return true;
      }
   }, []);

   return (
      <TextInput
         controller={props.register('payers.0.identificationNumber', {
            maxLength: 15,
            validate: validate,
         })}
         label={commonTranslationKeys.payerIdentificationNumber}
         testId={'payerIdentificationNumber'}
      />
   );
};
